import { useEffect } from 'react';
import { trackEvent } from '@kcd/event-tracker';

import { useMembershipStatus } from '~/app/hooks';
import { getBonusPackCouponAmountText } from '~/domains/plusMembership/utils';
import { openPageModal } from '~/utils/mobileApp';

import {
  BonuspackCloverFill18x18Icon,
  ChevronRightIcon,
  MembershipStandard28x14Icon,
} from '~/assets/icons';

/**
 * 상품 옵션 바텀시트에 노출되는 멤버십 가입유도 넛지 (App Router 버전).
 *
 * Pages 의 `CommonBottomsheetMembershipNudge` 를 이관한 것으로,
 * `~/app/hooks` 의 useMembershipStatus 와 openPageModal 래퍼를 사용한다.
 */
export function MembershipNudge() {
  const {
    isMembershipSubscribeServiceAvailable,
    isTrialAvailable,
    isAvailableToSubscribe,
    isAvailableToSubscribeBonusPack,
    getRegisterMembershipUrl,
  } = useMembershipStatus();

  const bonusPackCouponAmountText = getBonusPackCouponAmountText();

  const nudgeType = (() => {
    if (isTrialAvailable) {
      return 'plus_membership_free';
    }

    if (isAvailableToSubscribe) {
      return 'plus_membership';
    }

    if (isAvailableToSubscribeBonusPack) {
      return 'lucky_bonus_pack';
    }

    return '';
  })();

  useEffect(() => {
    if (nudgeType) {
      trackEvent('viewed banner in 마켓/상품상세/멤버십넛지', {
        clicked_area: 'product_option_botttom_sheet',
        membership_nudge_type: nudgeType,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickRegisterMembership = () => {
    const registerUrl = getRegisterMembershipUrl();

    trackEvent('clicked button in 마켓/상품상세/멤버십넛지', {
      clicked_area: 'product_option_botttom_sheet',
      membership_nudge_type: nudgeType,
    });

    if (registerUrl) {
      openPageModal(registerUrl);
    }
  };

  const nudgeContent = (() => {
    if (isTrialAvailable) {
      return (
        <button
          type="button"
          className="flex w-full items-center justify-between rounded-12 bg-blue-100 px-16 py-8"
          onClick={onClickRegisterMembership}
        >
          <span className="flex items-center gap-4 typo-paragraph100-regular">
            <MembershipStandard28x14Icon />총 6만원 쿠폰팩
          </span>
          <span className="flex items-center gap-4 text-accent typo-paragraph100-semibold">
            첫 4주 무료체험
            <ChevronRightIcon className="[&_path]:fill-blue-600" />
          </span>
        </button>
      );
    }

    if (isAvailableToSubscribe) {
      return (
        <button
          type="button"
          className="flex w-full items-center justify-between rounded-12 bg-blue-100 px-16 py-8"
          onClick={onClickRegisterMembership}
        >
          <span className="flex items-center gap-4 typo-paragraph100-regular">
            <MembershipStandard28x14Icon />총 6만원 쿠폰팩
          </span>
          <span className="flex items-center gap-4 text-accent typo-paragraph100-semibold">
            지금 구독하기
            <ChevronRightIcon className="[&_path]:fill-blue-600" />
          </span>
        </button>
      );
    }

    if (isAvailableToSubscribeBonusPack) {
      return (
        <button
          type="button"
          className="flex w-full items-center justify-between rounded-12 bg-blue-100 px-16 py-8"
          onClick={onClickRegisterMembership}
        >
          <span className="flex items-center gap-4 typo-paragraph100-regular">
            <BonuspackCloverFill18x18Icon />총 {bonusPackCouponAmountText}{' '}
            쿠폰팩에 보너스할인
          </span>
          <span className="flex items-center gap-4 text-accent typo-paragraph100-semibold">
            보러가기
            <ChevronRightIcon className="[&_path]:fill-blue-600" />
          </span>
        </button>
      );
    }

    return null;
  })();

  if (!isMembershipSubscribeServiceAvailable) return null;

  return <div className="py-8">{nudgeContent}</div>;
}
